import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import NetworkError from "../components/NetworkError";
import { useGetBranches } from "../hooks/useGetBranches";

const SelectBranch = () => {
  const navigate = useNavigate();

  // Fetch a large page so we have all branches available
  const { data: branches, isSuccess, isLoading, isError, error } = useGetBranches(1, 1000);

  useEffect(()=>{
  var branch = localStorage.getItem("selectedBranchId")
  if(branch){
      navigate("/categories");
  }
  },[])

  // Map to the shape you described: { name, value }
  const branchOptions = useMemo(
    () =>
      branches?.map((b) => ({
        name: `${b.branchName}`,
        value: b.branchCode,
      })) ?? [],
    [branches]
  );

  const [branchId, setBranchId] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!branchId) return;

    // Persist the selection so the rest of the app can use it
    localStorage.setItem("selectedBranchId", String(branchId));

    // If you also want the readable name (handy for headers):
    const picked = branchOptions.find((o) => String(o.value) === String(branchId));
    if (picked) {
      localStorage.setItem("selectedBranchName", picked.name);
    }

    // Go to categories next
    navigate("/categories");
  };

  if (isError && error?.code === "ERR_NETWORK") {
    return <NetworkError error={error} />;
  }

  return (
    <div className="w-full max-w-xl mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold mb-2">Select Branch</h1>
      <p className="text-sm text-gray-600 mb-6">
        Choose the branch you want to work with to continue.
      </p>

      {isLoading && <Loader className="fixed inset-0" />}

      {isSuccess && (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex flex-col space-y-1">
            <label htmlFor="branch" className="form-label">
              <span className='after:content-["*"] after:text-red-600/70'>Branch</span>
            </label>
            <select
              id="branch"
              className="form-input"
              required
              value={branchId}
              onChange={(e) => setBranchId(e.target.value)}
            >
              <option value="" className="text-slate-300">
                Select a branch
              </option>
              {branchOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.name}
                </option>
              ))}
            </select>
          </div>

          <button
            type="submit"
            disabled={!branchId}
            className="inline-flex items-center justify-center px-4 py-2 rounded bg-[#0A0D36] text-white disabled:opacity-50"
          >
            Continue
          </button>
        </form>
      )}
    </div>
  );
};

export default SelectBranch;
